module.exports = __webpack_public_path__ + "img/opay-light.5ea9d2a3.svg";